<template>
    <div
        v-if="warmingReleases.length"
        aria-hidden="true"
        class="pointer-events-none fixed left-[-9999px] top-0 h-px w-px overflow-hidden opacity-0"
    >
        <spotify-player
            v-for="release in warmingReleases"
            :key="release.playerRoute"
            :id="release.playerRoute"
            tabindex="-1"
            @load="onPlayerLoaded"
        />
    </div>
</template>

<script>
    // Components
    import {
        defineComponent, onBeforeUnmount, onMounted, ref, watch,
    } from 'vue';
    import { useRoute } from 'vue-router';
    import SpotifyPlayer from '@/components/players/SpotifyPlayer';
    // Library
    import store from '@/store/store';
    import { warmMerchCache } from '@/library/fetchMerch';
    import { isPreloadAllowed, onIdleAfterLoad, preloadImages } from '@/library/preload';

    const WARM_TIMEOUT = 20000;

    export default defineComponent({
        name: 'ContentPreloader',

        components: {
            SpotifyPlayer,
        },

        setup() {
            const route = useRoute();
            const warmingReleases = ref([]);

            let loadedCount = 0;
            let warmTimeout = null;

            const stopWarmingReleases = () => {
                window.clearTimeout(warmTimeout);
                warmingReleases.value = [];
            };

            const onPlayerLoaded = () => {
                loadedCount += 1;

                if (loadedCount >= warmingReleases.value.length) {
                    stopWarmingReleases();
                }
            };

            const preload = () => {
                if (route.name !== 'videos') {
                    preloadImages(store.getters.videos.map((video) => video.getThumbnailSrc()));
                }

                if (route.name !== 'shop') {
                    warmMerchCache();
                }

                if (route.name !== 'releases') {
                    warmingReleases.value = store.getters.releases.filter((release) => release.isSpotify());
                    warmTimeout = window.setTimeout(stopWarmingReleases, WARM_TIMEOUT);
                }
            };

            onMounted(() => {
                if (!isPreloadAllowed()) {
                    return;
                }

                onIdleAfterLoad(preload);
            });

            watch(() => route.name, (name) => {
                if (name === 'releases') {
                    stopWarmingReleases();
                }
            });

            onBeforeUnmount(stopWarmingReleases);

            return {
                warmingReleases,
                onPlayerLoaded,
            };
        },
    });
</script>
